<template>
  <div>
    <h1>Admin Tools</h1>

    <div class="row">
      <div class="col-4" v-if="isDeveloperUser">
        <ToolPanel name="Opening Balance - Glass Data" description="Setup all the glass data for the account when transferring from an existing system" icon="fa-pencil-ruler" link="/admin/tools/openingbalance/glass" />
      </div>
      <div class="col-4" v-if="isDeveloperUser">
        <ToolPanel name="Manual Usage - Glass Data" description="Setup all the historical glass usage data over previous months" icon="fa-exchange" link="/admin/tools/manualusage/glass" />
      </div>
      <div class="col-4">
        <ToolPanel name="Moving Average Calculator" description="Calculate moving averages for stock items" icon="fa-box-usd" link="/admin/tools/movingaverage" />
      </div>
    </div>

    <div class="row">
      <div class="col-4" v-if="isDeveloperUser">
        <ToolPanel name="Import" description="Import data from external sources" icon="fa-cloud-upload" link="/admin/tools/import" />
      </div>
      <div class="col-4" v-if="isDeveloperUser">
        <ToolPanel name="Export" description="Export data to files" icon="fa-cloud-download" link="/admin/tools/export" />
      </div>
    </div>

  </div>
</template>

<script>
import ToolPanel from '@/modules/admin/components/toolPanel.vue'

export default {
  components: {
    ToolPanel
  }
  
}
</script>